import React from 'react';
import LazyLoad from 'react-lazyload';
import DefaultImg from '../../../public/images/default-campaign-picture.jpg';

export const ImgLazyload = ({
  src = '',
  caption = 'Image',
  className = '',
  style = {},
  onLoad = () => {}
}) => (
  <LazyLoad once offset={50}>
    <img
      data-src={src?.includes('http') ? src : `/${src}`}
      src={src?.includes('http') ? src : `/${src}`}
      alt={caption}
      className={className}
      style={style}
      onLoad={onLoad}
      onError={(e) => {
        e.target.src = DefaultImg;
      }} />
  </LazyLoad>
);

export default ImgLazyload;
